<template>
  <span class="view-boolean" :id="field.key">
    <!-- Si es array, mostrar todos los valores -->
    <span v-if="field.isArray && Array.isArray(displayValue)">
      <span
        v-for="(boolValue, index) in displayValue"
        :key="index"
        class="boolean-item"
      >
        {{ boolValue === true ? "YES" : "NO" }}
        <span v-if="index < displayValue.length - 1">, </span>
      </span>
    </span>
    <!-- Valor simple -->
    <span v-else>
      {{ displayValue === true ? "YES" : "NO" }}
    </span>
  </span>
</template>

<script>
export default {
  name: "ViewFieldBoolean",
  props: {
    field: {
      type: Object,
      required: true,
    },
    value: {
      // String antes que Boolean: si no, Vue convierte un "" en `true` (ver editField).
      type: [String, Boolean, Array],
      default: null,
    },
    item: {
      type: Object,
      default: null,
    },
    modelName: {
      type: String,
      default: "",
    },
    isGroupModel: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    displayValue() {
      if (this.value !== null && this.value !== undefined) {
        return this.value;
      }
      if (this.field.defaultValue !== undefined && this.field.defaultValue !== null) {
        return this.field.defaultValue === true || this.field.defaultValue === "true";
      }
      return false;
    },
  },
};
</script>

<style scoped>
.view-boolean {
  font-weight: 500;
}

.boolean-item {
  display: inline;
}
</style>

